export default __webpack_public_path__ + "static/media/goopter-analytic-tools.ddad7a93.png";